<template>
  <div id="app">
    <link href='//fonts.googleapis.com/css?family=Lato' rel='stylesheet' type='text/css'>
    <router-view/>
  </div>
</template>

<script>
  import dashboard from './components/game-dashboard/Projects.vue'
  import login from './components/layout/Login.vue'
  export default {
    name: 'App',
    components: {
      dashboard,
      login
    }
  }
</script>

<style >
:root {
  --CARDBK: #fbfbfb;

  --QUESTIONS_WRAPPER_BACKGROUND: #fbfbfb;

  --TEMPLATE_ITEM_BORDER: #fbfbfb;
  --TEMPLATE_ITEM_BACKGROUND: #fbfbfb;

  --CARD_COLOR_BACKGROUND: #fbfbfb;

  --GAMEDM: #fbfbfb;

  --GAMETESTERB: #fbfbfb;
  --VIEWRES: #fbfbfb;

  --SESSION_ITEM_BORDER: #fbfbfb;
  --SESSION_ITEM_BACKGROUND: #fbfbfb;

  --BOTTONCOLOR: #FF7222 !important;;
  --BOTTONTEXTCOLOR: #FFFFFF !important;;
  --CONTRABOTTONCOLOR: #fbfbfb !important;;
  --TEXTCOLOR: #000000 !important;;
  --PROMPTCOLOR: #fbfbfb !important;;
  --PROMPTBKCOLOR: #fbfbfb!important;;
  --LOGINPAGE: #D9D9D9 !important;;
  --SCROLLPAGE: #f6f6f6 !important;;
  --LOGINCONTAINER: #FFFFFF !important;;
  --LOGINTITLE:#000000 !important;;

  --NAVTHEME: #fbfbfb;
  --NAVCTN: #fbfbfb;
  --NAVEFFECT:#fbfbfb;
  --TRIANGLE:#fbfbfb;
  --ACCOUNT:#fbfbfb;
  --LOGOUT:#fbfbfb;

  --LOADING: #fbfbfb;

  --tag-height: 35px;

  --MODIFYBK: #fbfbfb;
  --MODIFY: #fbfbfb;
  --CONFIRM: #fbfbfb;

  --USERPROFILE: #fbfbfb;
  --NICKNAME: #fbfbfb;

  --ADDGAMEC: #fbfbfb;
}


::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #FF7222;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #E55342;
}

#app {
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fade-leave-active {
  opacity: 0;
}

.fade-leave-active {
  transition: opacity 0.5s;
}

/* Shared Close Button Utility Classes */
.btn-close-circle {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  line-height: 1;
}

.btn-close-circle:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.btn-close-circle--dark {
  background: rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #333;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  line-height: 1;
  position:absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
}

.btn-close-circle--dark:hover {
  background: rgba(0, 0, 0, 0.12);
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

</style>



// WEBPACK FOOTER //
// src/App.vue